<template>
	<svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
		<circle cx="12" cy="12" r="12"/>
		<path fill="#fff" d="M16.5 21a5.25 5.25 0 1 1 3.5-9.1626.74969.74969 0 1 1-1 1.11719 3.74976 3.74976 0 1 0 0 5.59131.74969.74969 0 0 1 1 1.11719A5.24084 5.24084 0 0 1 16.5 21Z" class="cls-2" transform="translate(-4 -4)"/>
		<path fill="#fff" d="M15.25 15.75h-4.5a.75.75 0 0 1 0-1.5h4.5a.75.75 0 0 1 0 1.5Z" class="cls-2" transform="translate(-4 -4)"/>
		<path fill="#fff" d="M15.25 17.75h-4.5a.75.75 0 0 1 0-1.5h4.5a.75.75 0 0 1 0 1.5Z" class="cls-2" transform="translate(-4 -4)"/>
	</svg>
</template>
